export default [
    '477 477',
    '<path fill="currentColor" d="M451.882,208.359v-93.982L238.31,0L24.737,114.377v93.982H45.53v168.26H24.737v100h427.146v-100h-20.793v-168.26H451.882z\n' +
    '\t M194.05,376.619v-168.26h88.52v168.26H194.05z M54.737,178.359v-40h367.146v40H54.737z M377.101,108.359H99.519L238.31,34.031\n' +
    '\tL377.101,108.359z M75.53,208.359h88.52v168.26H75.53V208.359z M421.882,446.619H54.737v-40h367.146V446.619z M401.089,376.619\n' +
    '\th-88.52v-168.26h88.52V376.619z"/>'
]